import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { open, close } from '../../../helpers/index';

const Filters = ({ selected, facet, onFilterChange, onListDisplay }) => {
  const breakpoint = window.matchMedia('(max-width: 1280px)');
  const { keyword, name } = facet;
  const [display, setDisplay] = useState(!breakpoint.matches);
  const [currentFacet, setCurrentFacet] = useState(facet);
  const filterList = useRef(null);

  const handleSelect = value => {
    const selectedClone = [...selected];

    if (selectedClone.includes(value)) {
      selectedClone.splice(selectedClone.indexOf(value), 1);
    } else {
      selectedClone.push(value);
    }

    const facetItems = {
      name: keyword,
      options: selectedClone
    };

    onFilterChange(facetItems);
  };

  useEffect(() => {
    currentFacet.options.map((option, index) => {
      if (option.value !== facet.options[index].value) {
        setCurrentFacet(facet);
      }
      if (option.matches !== facet.options[index].matches) {
        setCurrentFacet(facet);
      }
    });
  }, [currentFacet]);

  useEffect(() => {
    setCurrentFacet(facet)
  }, [facet]);

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplay(false);
      } else {
        setDisplay(true);
      }
    };

    breakpoint.addListener(listener);
    return () => breakpoint.removeListener(listener);
  }, []);

  useEffect(() => {
    if (display) {
      filterList.current.style = null;
      open({ element: filterList.current });
    } else {
      close({
        element: filterList.current,
        onComplete: () => {
          filterList.current.style.visibility = 'hidden';
        }
      });
    }
  }, [display, currentFacet]);

  return (
    <>
      <div className="search-results__facet">
        <button
          className={`search-results__facet-title-btn${
            display ? ' search-results__facet-title-btn--open' : ''
          }`}
          onChange={() => onListDisplay()}
          onClick={() => setDisplay(!display)}
        >
          {name}
          <div className="search-results__facet-title-icon">
            <span>{display ? '-' : '+'}</span>
          </div>
        </button>
        <div
          className="search-results__listing"
          data-list-from={keyword}
          ref={filterList}
        >
          <div className="search-results__facet-list-inner">
            {currentFacet.options.map((option, i) => {
              return (
                <div
                  key={i}
                  className={
                    option.disabled
                      ? 'search-results__facet-option disabled'
                      : 'search-results__facet-option'
                  }
                >
                  <label
                    className="search-results__facet-input"
                    htmlFor={option.name}
                  >
                    <input
                      type="checkbox"
                      name={option.name}
                      id={option.name}
                      checked={
                        option.selected || selected.includes(option.value)
                      }
                      onChange={() => handleSelect(option.value)}
                      disabled={option.disabled}
                    />
                    <span className="checkmark"></span>
                    {option.name}
                  </label>
                  <p
                    className={
                      option.selected || selected.includes(option.value)
                        ? 'search-results__facet-count search-results__facet-count--selected'
                        : 'search-results__facet-count'
                    }
                  >
                    {option.matches}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

Filters.propTypes = {
  facets: PropTypes.array
};

export default Filters;
